
/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";
const { subscribe, set, update } = writable({isUpdated:false});
import { update as updateDB } from '../../api';
const module_name = 'topper'

export const videoEditStore = {
  subscribe,
  set,
  update,
  SetKeywords: (keywords) => {
    update(v => {
      v.keywords = keywords;
      return v
    })
  },
  SetIabCategories: (iab) => {
    update(v => {
      v.iab_categories = iab;
      return v
    })
  },

  Save: async (data) => {
    try {
      const response = await  updateDB(module_name,data);
      if (response?.status === 'ok') {
        update(v=> {
          v.isUpdated = true
          return v
        })
      }
     
    } catch (error) {
      update(v=> {
        v.isUpdated = true
        return v
      })
      console.error('Error:', error);
    }
  }
};


